let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hMh6Q")).then(() => parcelRequire('8Snjq'));